// Deprecated: This service is a temporary solution for tracking analytics events
// It will be replaced by a frontend tracking solution in the future
import { post } from './api';

export type AnalyticsEvent =
  | 'rules_of_road_accepted'
  | 'session_resumed'
  | 'session_dismissed'
  | 'clear_all_completed_tasks'
  | 'task_created'
  | 'tracked_action_created'
  | 'recommended_task_added'
  | 'recommended_task_dismissed'
  | 'recommended_tasks_cleared'
  | 'tracked_action_updated'
  | 'task_updated'
  | 'task_reopened'
  | 'subtask_added'
  | 'subtask_deleted'
  | 'subtask_uncompleted'
  | 'subtask_completed'
  | 'tracked_actions_viewed'
  | 'tracked_actions_filtered'
  | 'recommended_tasks_refreshed'
  | 'manage_channels_opened'
  | 'channel_preferences_saved'
  | 'channel_preferences_save_failed'
  | 'task_section_expanded'
  | 'task_section_collapsed'
  | 'task_dragged'
  | 'task_dropped'
  | 'task_reordered'
  | 'filter_applied'
  | 'filter_cleared'
  | 'quick_action_opened'
  | 'quick_action_used'
  | 'task_limit_reached'
  | 'task_limit_dialog_shown'
  | 'focus_time_scheduled'
  | 'add_task_clicked'
  | 'new_badge_displayed'
  | 'new_badge_dismissed'
  | 'accessbility_feature_used'
  | 'keyboard_navigation_used'
  | 'task_manually_created_per_day'
  | 'task_recommended_per_day'
  | 'task_tracked_others_per_day'
  | 'task_moved_cross_section'
  | 'chat_feedback_submitted'
  | 'chat_suggestion_selected'
  | 'overview_insight_feedback_submitted';

export interface TrackEventPayload {
  event: AnalyticsEvent;
  timestamp: string;
  metadata?: Record<string, unknown>;
}

/**
 * Analytics service for tracking user events
 * Note: This is a temporary solution that will be replaced by a frontend tracking solution
 */
export const analyticsService = {
  /**
   * Track an analytics event by sending it to the backend
   */
  trackEvent: async (event: AnalyticsEvent, metadata?: Record<string, unknown>): Promise<void> => {
    try {
      const payload: TrackEventPayload = {
        event,
        timestamp: new Date().toISOString(),
        metadata,
      };

      await post('/api/v1/analytics/track', payload);
    } catch (error) {
      // Silently fail - don't interrupt user experience for analytics failures
      console.warn('Failed to track analytics event:', event, error);
    }
  },
};
